import { createContext } from "react";

const ItemsContext = createContext();

export default ItemsContext;